import { LatLng, insideCircle } from "geolocation-utils";

import { Utils } from "utils";
import { Road } from "services/road";
import { IPlace, Prettify, Iterable } from "types";

interface Props {
  coordinates: LatLng[];
  gaps: [number, number];
  searchRadius: number; // km
  places: Iterable<IPlace>[];
}

export const getPlacesAlongCoordinates = (props: Prettify<Props>) => {
  const { coordinates, gaps, searchRadius, places } = props;

  const road = Road.fromLatLng(coordinates);
  const circles = road.circles({ radius: searchRadius, gaps });

  const filtered = places.filter((place) => {
    const location = Utils.Places.getRouteCoordinates(place);

    const hasLocationsInside = circles.find((item) => {
      const radius = item.radius;
      const circle = { lat: item.lat, lng: item.lng };
      return insideCircle(location, circle, radius);
    });

    return Boolean(hasLocationsInside);
  });

  return filtered;
};
